<template>
  <BaseCard
    :title="title"
    :marketing-tag="marketingTag"
    :desc="desc"
    :tags="tags"
    :image-url="imageUrl"
    :pay-amount="payAmount"
    :total-original-price="totalOriginalPrice"
    :prev-text="prevText"
    :pay-type-desc="payTypeDesc"
  />
</template>

<script>
import BaseCard from './Base';

export default {

  components: {
    BaseCard,
  },

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      desc: '',
      totalOriginalPrice: undefined,
      prevText: '',
      imageUrl: '',
      payAmount: undefined,
      title: '',
      marketingTag: '',
      payTypeDesc: '',
      tags: [],
    };
  },

  watch: {
    item() {
      this.load();
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      const {
        totalOriginalPrice,
        prevText,
      } = this.item.payType === 1
        ? this.getInstallmentParams(this.item)
        : this.getParams(this.item);
      this.totalOriginalPrice = totalOriginalPrice;
      this.prevText = prevText;
      const { item } = this;
      const {
        imageUrl,
        payAmount,
        title,
        tagList,
        subTitle,
        marketingTag,
        payTypeDesc,
      } = item;

      this.imageUrl = imageUrl;
      this.payAmount = payAmount;
      this.title = title;
      this.payTypeDesc = payTypeDesc;
      this.desc = subTitle;
      this.marketingTag = marketingTag;
      this.tags = (tagList || []).map((it) => it.title);
    },

    // 普通支付参数
    getParams(item) {
      const { totalOriginalPrice } = item;

      return {
        totalOriginalPrice,
        prevText: '',
      };
    },
    // 分期支付参数
    getInstallmentParams() {
      return {
        totalOriginalPrice: '',
        prevText: '首期',
      };
    },
  },
};
</script>
